<script>
import {defineComponent} from 'vue'
import FormattedNumberInput from "@js/components/Input/FormattedNumberInput.vue";
import NumberFormatComponent from "@js/components/Formatter/NumberFormatComponent.vue";
import {useCalculatorStore} from "@js/store/CalculatorStore.js";

export default defineComponent({
    name: "SVPCalculator",
    components: {NumberFormatComponent, FormattedNumberInput},
    setup() {
        const calculatorStore = useCalculatorStore()

        return {calculatorStore}
    }
})
</script>

<template>
    <div class="grid grid-cols-12 gap-5 md:gap-10">
        <div class="col-span-12 md:col-span-7">
            <div class="md:bg-grayBg md:rounded-lg md:p-8">
                <div>
                    <p v-if="calculatorStore.svp_calc.error_message"
                       class="text-red-600 font-bold mb-5">
                        {{ calculatorStore.svp_calc.error_message }}
                    </p>
                    <div class="mb-5 md:mb-10">
                        <p class="text-xl font-semibold mb-5">
                            Параметры облицовки
                        </p>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-5">
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tsvpp_length" id="tsvpp_length"
                                                      v-model="calculatorStore.svp_calc.calc_data.tile_length"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tsvpp_length"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Длина плитки (мм)
                                </label>
                            </div>
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tsvpp_width" id="tsvpp_width"
                                                      v-model="calculatorStore.svp_calc.calc_data.tile_width"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tsvpp_width"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Ширина плитки (мм)
                                </label>
                            </div>
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tsvpp_height" id="tsvpp_height"
                                                      v-model="calculatorStore.svp_calc.calc_data.facing_area"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tsvpp_height"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Площадь облицовки (м2)
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="mb-5 md:mb-10">
                        <p class="text-xl font-semibold mb-5">
                            Упаковка клиньев
                        </p>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-5 mb-5">
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tsvpuk_box_count" id="tsvpuk_box_count"
                                                      v-model="calculatorStore.svp_calc.calc_data.wedges_count_in_box"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tsvpuk_box_count"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Количество в упаковке (шт)
                                </label>
                            </div>
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tsvpuk_count_price" id="tsvpuk_count_price"
                                                      v-model="calculatorStore.svp_calc.calc_data.wedges_box_price"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tsvpuk_count_price"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Стоимость упаковки (₽)
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="mb-5 md:mb-10">
                        <p class="text-xl font-semibold mb-5">
                            Упаковка зажимов
                        </p>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-5 mb-5">
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tsvpuk_box_count" id="tsvpuk_box_count"
                                                      v-model="calculatorStore.svp_calc.calc_data.clamp_count_in_box"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tsvpuk_box_count"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Количество в упаковке (шт)
                                </label>
                            </div>
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tsvpuk_count_price" id="tsvpuk_count_price"
                                                      v-model="calculatorStore.svp_calc.calc_data.clamp_box_price"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tsvpuk_count_price"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Стоимость упаковки (₽)
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <button type="button"
                            @click.prevent="calculatorStore.svpCalculate"
                            class="flex items-center justify-center w-full gap-2 leading-tight uppercase text-nowrap bg-baseColor md:hover:bg-baseColor/80 text-black focus:outline-none focus:ring-0 font-bold rounded-xl text-sm px-5 py-4 transition mt-5">
                        Рассчитать
                    </button>
                    <div class="mt-5 pt-5 border-t border-gray-300"
                         v-if="calculatorStore.svp_calc.is_calculated">
                        <p class="text-xl font-semibold mb-5">
                            Результат расчета:
                        </p>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-5 mb-4">
                            <div
                                class="flex flex-col justify-between bg-white rounded-2xl p-5 md:p-6 shadow transition-shadow md:hover:shadow-lg">
                                <div class="font-bold text-sm text-gray-600">
                                    Требуемое количество клиньев + Зажимов
                                </div>
                                <div
                                    class="font-semibold whitespace-pre-line break-words text-xl md:text-2xl mt-2">
                                    <NumberFormatComponent :number="calculatorStore.svp_calc.result.totalWedges"
                                                           append_text="шт."/>
                                    +
                                    <NumberFormatComponent :number="calculatorStore.svp_calc.result.totalClamps"
                                                           append_text="шт."/>
                                </div>
                            </div>
                            <div
                                class="flex flex-col justify-between bg-white rounded-2xl p-5 md:p-6 shadow transition-shadow md:hover:shadow-lg">
                                <div class="font-bold text-sm text-gray-600">
                                    Количество упаковок клиньев + Зажимов
                                </div>
                                <div
                                    class="font-semibold whitespace-pre-line break-words text-xl md:text-2xl mt-2">
                                    <NumberFormatComponent :number="calculatorStore.svp_calc.result.wedgeBoxCount"
                                                           append_text="шт."/>
                                    +
                                    <NumberFormatComponent :number="calculatorStore.svp_calc.result.clampBoxCount"
                                                           append_text="шт."/>
                                </div>
                            </div>
                            <div
                                class="flex flex-col justify-between bg-white rounded-2xl p-5 md:p-6 shadow transition-shadow md:hover:shadow-lg">
                                <div class="font-bold text-sm text-gray-600">
                                    Стоимость клиньев
                                </div>
                                <div
                                    class="font-semibold whitespace-pre-line break-words text-xl md:text-2xl mt-2">
                                    <NumberFormatComponent :number="calculatorStore.svp_calc.result.wedgesCost"
                                                           append_text=" ₽"/>
                                </div>
                            </div>
                            <div
                                class="flex flex-col justify-between bg-white rounded-2xl p-5 md:p-6 shadow transition-shadow md:hover:shadow-lg">
                                <div class="font-bold text-sm text-gray-600">
                                    Стоимость зажимов
                                </div>
                                <div
                                    class="font-semibold whitespace-pre-line break-words text-xl md:text-2xl mt-2">
                                    <NumberFormatComponent :number="calculatorStore.svp_calc.result.clampsCost"
                                                           append_text=" ₽"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-span-12 md:col-span-5">
            <div>
                <h2 class="text-2xl font-semibold mb-6">
                    Расчёт СВП для укладки плитки — Пошаговое руководство
                </h2>
                <ol class="list-decimal list-outside ps-5 space-y-3 text-base">
                    <li>
                        Укажите параметры облицовываемой поверхности — длину и ширину плитки, площадь покрытия.
                    </li>
                    <li>
                        Введите, сколько упаковок клиньев у вас имеется.
                    </li>
                    <li>
                        Укажите цену одной упаковки клиньев в рублях.
                    </li>
                    <li>
                        Клинья — это многоразовые элементы, которые можно использовать в нескольких укладках подряд.
                        Поэтому их количество не всегда должно совпадать с числом зажимов.
                    </li>
                    <li>
                        Укажите количество упаковок с зажимами.
                    </li>
                    <li>
                        Введите стоимость одной упаковки зажимов.
                    </li>
                    <li>
                        Если вы используете упаковки с разным количеством элементов, выполните расчёты отдельно
                        для каждого вида и сложите итоговые значения вручную.
                    </li>
                    <li>
                        Нажмите «Рассчитать», чтобы увидеть примерный расход СВП для укладки плитки.
                    </li>
                </ol>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
